import script from "./CurrentUserButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CurrentUserButton.vue?vue&type=script&setup=true&lang=js"

import "./CurrentUserButton.vue?vue&type=style&index=0&id=e1806954&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2503735441/src/recipe-ai-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e1806954"]])

export default __exports__